import { Box, Link, Typography } from '@mui/material';

export default function RegulatoryNotice(props) {
  return (
    <Box {...props}>
      <Typography component="div" sx={{ color: 'grey.700' }} variant="caption">
        <sup>*</sup>
        {' '}
        5 Jahre Herstellergarantie bis 100.000 km. Danach bis zu 3-mal je 1 Jahr
        Anschlussgarantie, bis max. 160.000 km, der Mitsubishi Motors Europe B.V.,
        Postbus 157, 6130 AD Sittard, Niederlande, für wesentliche Bauteile. 8
        Jahre Herstellergarantie auf die Fahrbatterie bis 160.000 km. Gültig für
        neu eingeführte Mitsubishi Modelle ab 2025. Die Herstellergarantie beginnt
        mit der Erstzulassung des Fahrzeugs. Jeweils gemäß den entsprechenden
        Garantiebedingungen. Bedingungen und Details unter:
        {' '}
        <Link
          href="https://www.mitsubishi-motors.de/garantiepaket"
          target="_blank"
        >
          www.mitsubishi-motors.de/garantiepaket
        </Link>
      </Typography>
    </Box>
  );
}
